export default __webpack_public_path__ + "static/media/map7.5168c8db.png";